import React, { useRef, useState, useEffect } from 'react';
import LaddaButton, { XL, SLIDE_UP } from 'react-ladda';
import PropTypes from 'prop-types';
import AvatarGenerator from 'react-avatar-generator';

import { Input } from '../components';

const Dashboard = props => {
  const {
    account: {
      email, username, balance, loading,
    },
    setBalance,
    getBalance,
    logout,
    history,
    isTest,
  } = props;
  const avatarGenerator = useRef();
  const [newBalance, setNewBalance] = useState('0');
  const changeNewBalance = e => setNewBalance(e.target.value);
  const endSession = () => logout(history);
  const increaseBalance = () => setBalance(newBalance);
  useEffect(() => {
    setTimeout(() => {
      getBalance();
    }, 1000);
    const id = setInterval(() => avatarGenerator.current.randomize(), 2000);
    return () => clearInterval(id);
  }, [getBalance]);
  const showLoader = loading.some(url => url === 'balance');
  return (
    <div id="right-pane">
      <div>
        <button className="button small-button" onClick={endSession}>Log out</button>
      </div>
      <div>
        {
          !isTest
          && (
          <AvatarGenerator
            ref={el => {
              avatarGenerator.current = el;
            }}
            width={50}
            height={50}
            colors={['#333', '#222', '#ccc']}
            backgroundColor="#000"
          />
          )
        }
      </div>
      Welcome,
      {' '}
      {username}
      <br />
      Your email is
      {email}
      <br />
      Your balance is
      {'\u20A6'}
      {balance / 100}
      <div id="balance">
        Increase your balance by
        <Input
          className="input small-input"
          type="number"
          placeholder="0.00"
          value={newBalance}
          onChange={changeNewBalance}
          onError={() => {}}
        />
        (in kobo)
      </div>
      <div>
        <LaddaButton
          className="button"
          loading={showLoader}
          onClick={increaseBalance}
          data-color="#000000"
          data-size={XL}
          data-style={SLIDE_UP}
          data-spinner-size={30}
          data-spinner-color="#000000"
          data-spinner-lines={6}
        >
          {showLoader ? '' : 'Save'}
        </LaddaButton>
      </div>
    </div>
  );
};

Dashboard.propTypes = {
  account: PropTypes.shape({
    balance: PropTypes.number,
    email: PropTypes.string,
    loading: PropTypes.arrayOf(PropTypes.string).isRequired,
    username: PropTypes.string,
  }),
  getBalance: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  isTest: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  setBalance: PropTypes.func.isRequired,
};

export default Dashboard;
